<div class="flex h-[50rem] flex-col gap-2" *transloco="let t">
  <app-keyword-list-manager
    class="min-h-0 flex-1"
    [addInputPlaceholder]="t('brand-alias-modal.enter_list_name_brand_placeholder')"
    [maxWordPerKeyword]="4"
    [targetingMode]="false"
    [initTargetings]="toTargetings()"
    [isReadOnly]="modalData.isReadOnly"
    (targetingsChanged)="onKeywordsChanged($event)"
  />
  <div class="flex justify-end gap-2" *transloco="let t">
    <button iButton variant="secondary" size="md" (click)="close()">{{ t("common.close") }}</button>
  </div>
</div>
